// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MuiTabs-scrollButtons.Mui-disabled {\r\n  opacity: 0.3;\r\n}", "",{"version":3,"sources":["webpack://./src/uni-questionnaire/components/AppBarTabs.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd","sourcesContent":[".MuiTabs-scrollButtons.Mui-disabled {\r\n  opacity: 0.3;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
